/* ---------------------------------------------------- */
/* RESIZE BANNER VARIABLES --------------------------------------------- */
var max_font_size = 30;
var txt_unit = [];
var compteur = 0;

$j(document).ready(function () {

    /**
     * Responisve image
     */
    if($j('.responsive-img').length > 0){
        $j('.responsive-img').css('display', 'inherit');
    }


    /* ---------------------------------------------------- */
  /* RESIZE BANNER FUNCTIONS --------------------------------------------- */
  function firstfunction(){
   $j(".resizer").each(function(){
    var conteneur_width = $j(this).width()*0.9;
    var txt = $j(this).find("span");
    txt.css('font-size', "1px");
    txt_unit[compteur] = txt.width() / txt.css("font-size").substring(0,txt.css("font-size").length-2);
    compteur++;
   });
   compteur = 0;
  }

  function resizeTexte(){
    firstfunction();
    $j(".resizer").each(function(){
      var conteneur_width = $j(this).width()*0.9;
      var txt = $j(this).find("span");
      var final_size = conteneur_width / txt_unit[compteur];

      if(final_size > max_font_size)
      {
        final_size = max_font_size;
      }
      txt.css('font-size', final_size+"px");
      compteur++;
     });
     compteur = 0;
  }
  
 /* ---------------------------------------------------- */
 /* OUT OF STOCK (TEST IOS) --------------------------------------------- */
      var isMobile = {
          Android: function() {
              return navigator.userAgent.match(/Android/i);
          },
          BlackBerry: function() {
              return navigator.userAgent.match(/BlackBerry/i);
          },
          iOS: function() {
              return navigator.userAgent.match(/iPhone|iPad|iPod/i);
          },
          Opera: function() {
              return navigator.userAgent.match(/Opera Mini/i);
          },
          Windows: function() {
              return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
          },
          any: function() {
              return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
          }
      };
      if( isMobile.iOS() )
      {
          $j("#product-options-wrapper select").each(function(){
              $j(this).prepend("<optgroup>");
              $j(this).append("<optgroup>");
          });
      }
/* ---------------------------------------------------- */
/* RESIZE BANNER FUNCTIONS CALL --------------------------------------------- */
  firstfunction();
  if (document.addEventListener){
      window .addEventListener('resize', resizeTexte); 
  } else if (document.attachEvent){
      window.attachEvent('onresize', resizeTexte);
  }
  resizeTexte();
  
  
/* ---------------------------------------------------- */
/* SCROLL --------------------------------------------- */

  /* - SCROLL Animate Ancre - */
  $j('.cms a[href^="#"]').click(function(){
    var the_id = $j(this).attr("href");
    var speed = 750;
    $j('html, body').animate({ scrollTop:($j(the_id).offset().top)-50 }, speed);
    return false;
  });

  /* - SCROLL Top Add To Cart - */
  $j('#product-addtocart-button').click(function(){
      $j("html, body").animate({ scrollTop: 0 }, 400);
      return false;
  });

   $j('#onestepcheckout-login-link').click(function(){
    $j("html, body").animate({ scrollTop: 0 }, 400);
      return false;
  });
   $j('#pop-bed').click(function(){
    $j("html, body").animate({ scrollTop: 0 }, 400);
      return false;
  });
    $j('a[rel^="prettyPhoto"]').click(function(){
      
      $j("html, body").animate({ scrollTop: 0 }, 400);
      return false;
  });

  /* - SCROLL Ancre FadeIn / FadeOut - */
  $j(function(){
    var shrinkHeader = 250;
    $j(window).scroll(function() {
      var scroll = getCurrentScroll();
      if ( scroll >= shrinkHeader ) {
        $j('#scrolltop').fadeIn();
      }
      else {
        $j('#scrolltop').fadeOut();
      }
    });
      function getCurrentScroll() {
      return window.pageYOffset || document.documentElement.scrollTop;
    }
  });

  
  // smooth scroll 
  $j('.scrollto').click( function() { // Au clic sur un élément
    var page = $j(this).attr('href'); // id cible
    var speed = 750; // Durée de l'animation (en ms)
      $j('html, body').animate( { scrollTop: $j(page).offset().top }, speed ); // Go
      return false;
  });
/* --------------------------------------------------- */
/* MENU ---------------------------------------------- */

  /* - Bouton Menu Main Mobile / Tablette - */
  $j("#cta-nav").click(function(event) {
    $j(this).toggleClass('nav-inactive nav-active');
    $j('#nav').slideToggle();
  });

  /* - Bouton Menu Left Mobile / Tablette - */
  $j("#cta-nav-left").click(function(event) {
    $j(this).toggleClass('nav-inactive nav-active');
    // $j('#nav-left').toggle();
  });
  $j("#cta-nav-left-menu").click(function(event) {
    $j('#cta-nav-left').toggleClass('nav-inactive nav-active');
    // $j('#nav-left').toggle();
  });

  /* - Bouton search / Desktop - */
  $j("#cta-nav-search").click(function(event) {
    $j(this).toggleClass('nav-inactive nav-active');
    $j('#header #nav-search').toggle();
    $j('#search').focus();
  });

  $j("#header .search.mobile").click(function(){
    $j("#search_mini_form-mobile").toggle();
  });

  /* - Boutou Menu Left Mobile / Tablette - */
  $j(".close-msg").click(function(event) {
    $j('.messages').fadeOut();
  });
/* --------------------------------------------------- */
/* Out of stock IOS ---------------------------------------------- */
      var isMobile = {
          Android: function() {
              return navigator.userAgent.match(/Android/i);
          },
          BlackBerry: function() {
              return navigator.userAgent.match(/BlackBerry/i);
          },
          iOS: function() {
              return navigator.userAgent.match(/iPhone|iPad|iPod/i);
          },
          Opera: function() {
              return navigator.userAgent.match(/Opera Mini/i);
          },
          Windows: function() {
              return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
          },
          any: function() {
              return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
          }
      };
      if( isMobile.iOS() )
      {
          $j("#product-options-wrapper select").each(function(){
              $j(this).prepend("<optgroup>");
              $j(this).append("<optgroup>");
          });
      }


  /* top banner */
  if ($j('.top-banner.earn-burn') && $j('.top-banner.earn-burn').css('display') !== 'none') {
    $j('#header-warrper').css({'top': $j('.top-banner.earn-burn').outerHeight() + 'px'}).css({'position': 'relative'})
    $j('.promo_banner').css({'top': $j('.top-banner.earn-burn').outerHeight() + 'px'}).css({'position': 'relative'})
    $j('#warpper').css({'top': $j('.top-banner.earn-burn').outerHeight() + 'px'}).css({'position': 'relative'})
    $j('#footer').css({'top': $j('.top-banner.earn-burn').outerHeight() + 'px'}).css({'position': 'relative'})
    $j('#copyright').css({'top': $j('.top-banner.earn-burn').outerHeight() + 'px'}).css({'position': 'relative'})
  }

/* --------------------------------------------------- */
/* MENU ---------------------------------------------- */

  /* - Boutou Menu Main Mobile / Tablette - */
  // $j("#cta-nav").click(function(event) {
  //   $j(this).toggleClass('nav-inactive nav-active');
  //   $j('#nav').toggle();
  // });

  /* - Boutou Menu Left Mobile / Tablette - */
  $j("#cta-nav-left").click(function(event) {
    $j(this).toggleClass('nav-inactive nav-active');
    $j('#nav-left').toggle();
  });


/* --------------------------------------------------- */
/* SWITCH LANGUE VIEW ------------------------------- */

  //fermeture lang base 
  $j("#cta-nav-lang").click(function(event){
      //minicart close
      if ($j("#cartpopup").css("display") == "block") {
          Effect.SlideUp("cartpopup", {duration: 0.3});
          mouseDisplayPopin.bind(this).delay(0.3);
      }
      //eo minicart
      $j(this).toggleClass('nav-active nav-inactive');
      $j("#nav-lang").toggle();
      // stop la propagation du clic
      event.stopPropagation();
  });

  // Fonction fermeture de balise lang - click à l'extérieure
  $j('body').click(function(event){
    //on recupère ID de l'éléments sélectionné par la souris
    var el = event.target.id;
    if ($j("#cta-nav-lang").hasClass("nav-active") && el != "nav-lang"){
      //condition pour ne pas fermer pas la balise si on click sur les éléments enfants
      if($j(event.target).parents("ul").attr('id') == "nav-lang" ){
      //ne rien faire
        }else{
            $j("#cta-nav-lang").toggleClass('nav-active nav-inactive');
            $j("#nav-lang").slideToggle("fast");
        }
    }
  });
  $j("#cta-nav-lang-footer").click(function(event){
      $j(this).toggleClass('nav-active nav-inactive');
      $j("#nav-lang-footer").slideToggle("fast");

      // if($j(this).hasClass('nav-active'))
      // {
      //   console.log("activation");
      //   $j("#nav-lang-footer").SlideUp();
      // }
      // else{
      //   console.log("desactivation");
      //   $j("#nav-lang-footer").SlideDown();
      // }
      // stop la propagation du clic
      event.stopPropagation();
  });

  // Fonction fermeture de balise lang - click à l'extérieure
  $j('body').click(function(event){
    //on recupère ID de l'éléments sélectionné par la souris
    var el = event.target.id;
    if ($j("#cta-nav-lang-footer").hasClass("nav-active") && el != "nav-lang-footer"){
      //condition pour ne pas fermer pas la balise si on click sur les éléments enfants
      if($j(event.target).parents("ul").attr('id') == "nav-lang-footer" ){
      //ne rien faire
        }else{
            $j("#cta-nav-lang-footer").toggleClass('nav-active nav-inactive');
            $j("#nav-lang-footer").slideToggle("fast");
        }
    }
  });

  // BED DISCLAIMER close
  $j(".close-bed-disclaimer").click(function(){
    $j(".dialog").fadeOut();
    $j("#pop-overlay").fadeOut();
  });


/* --------------------------------------------------- */
/* CURRENCY SELECTOR ------------------------------------------- */
    // Toggle for currency selector
    $j("#move-currency").click(function(event){
      $j(this).toggleClass('nav-active nav-inactive');
      $j("#nav-currency").toggle();
      event.stopPropagation();
  });

  $j('body').click(function(event){
      var el = event.target.id;
      if ($j("#move-currency").hasClass("nav-active") && el != "nav-currency"){
          if($j(event.target).parents("ul").attr('id') == "nav-currency" ){
              // do nothing
          } else {
              $j("#move-currency").toggleClass('nav-active nav-inactive');
              $j("#nav-currency").slideToggle("fast");
          }
      }
  });


  
/* --------------------------------------------------- */
/* SEARCH ------------------------------------------- */
  
  $j("#cta-nav-search").click(function(event) {
    $j(this).toggleClass('nav-inactive nav-active');
    $j('#header #nav-search').toggle();
    $j('#search').focus();
  });

/* --------------------------------------------------- */
/* OVERLAY ------------------------------------------- */

    $j('#pop-overlay').click(function(event){
    $j("#ajaxnotice").hide();
    $j("#pop-overlay").fadeOut();
    $j(".dialog").hide();
    $j(".messages").hide();
    $j("#dialog_system").hide();
    $j("#promo-pop").fadeOut();
  });

    /* ------ POP UP MESSAGE VALIDATION ------ */

    if( $j("#admin_messages").text() != "" ){
      $j("#pop-overlay").fadeIn('fast');
      $j(".messages").fadeIn('fast');
      $j("input").blur();
    }

    if( $j(".messages").text() != "" ){
      $j("#pop-overlay").fadeIn('fast');
      $j(".messages").prepend("<div class='dialog_close'></div>");
      $j("input").blur();
      if ($j(".main .messages li").hasClass('error-msg')){
        $j(".messages").addClass('error-msg');
      }
      $j(".messages").fadeIn('fast');
    }

    $j(".dialog_close").click(function(event){
      $j(".messages").hide();
      $j("#pop-overlay").hide();
    });

/* --------------------------------------------------- */
/* CHECKOUT ------------------------------------------ */

  // OneStepcheckout -- Error shipping
  $j("#onestepcheckout-place-order").click(function(event){
    if( $j('input[name=shipping_method]').is(':checked')){
      $j(".onestepcheckout-shipping-method-block").first().removeClass("shipping-empty-error")
    } else{
      $j(".onestepcheckout-shipping-method-block").first().addClass("shipping-empty-error");
    }});

  // OneStepcheckout -- Coupon
  $j(".onestepcheckout-coupons label").click(function(event){
    $j(".coupon-container").slideToggle(150);
  });

  // tab product view

  $j(".pro-coll-menu #tab-desc").click(function(){
    $j(".pro-coll-menu li").removeClass("visible");
    $j(".desc-info").removeClass("visible");

    $j(".pro-coll-menu #tab-desc").addClass("visible");
    $j(".desc-info#description").addClass("visible");
  });
   $j(".pro-coll-menu #tab-inf").click(function(){
    $j(".pro-coll-menu li").removeClass("visible");
    $j(".desc-info").removeClass("visible");

    $j(".pro-coll-menu #tab-inf").addClass("visible");
    $j(".desc-info#information-tech").addClass("visible");
  });
  
  $j(".pro-coll-menu #tab-earn-and-burn").click(function(){
    $j(".pro-coll-menu li").removeClass("visible");
    $j(".desc-info").removeClass("visible");

    $j(".pro-coll-menu #tab-earn-and-burn").addClass("visible");
    $j(".desc-info#earn-and-burn-copy").addClass("visible");
  });

    $j(".pro-coll-menu #tab-shipping").click(function(){
    $j(".pro-coll-menu li").removeClass("visible");
    $j(".desc-info").removeClass("visible");

    $j(".pro-coll-menu #tab-shipping").addClass("visible");
    $j(".desc-info#shipping").addClass("visible");
  });


    // FOOTER link mobile
  $j(".entete.contact").click(function(){
    $j(".deroule.contact").slideToggle("fast");
  });
  $j(".entete.customer").click(function(){
    $j(".deroule.customer").slideToggle("fast");
  });
  $j(".entete.connected").click(function(){
    $j(".deroule.connected").slideToggle("fast");
  });
$j('#overlay_related').click(function(event){
    $j("#overlay_related").fadeOut(200);
  });
  $j('.dialog_close').click(function(event){
    $j("#overlay_related").fadeOut(200);
  });

});


function popRelated(src){
    $j(".popImgRel").attr("src",src);
    $j("#overlay_related").fadeIn(200);
}

$j(document).ready(function () {
    // Manage related products
    if($j('#block-related')){

        // Observe related product checkboxes change
        $$('.related-checkbox').each(function(checkbox){
            Event.observe(checkbox, 'click', function(){
              var relatedProductsFieldValue = [];
              $$('.related-checkbox:checked').each(function(e){relatedProductsFieldValue.push(e.value)});
                if($('related-products-field')){
                    $('related-products-field').value = relatedProductsFieldValue.join(',');
                    $('related-products-qty').value = $j('input#qty').val();
                }
            })
        })

        // Observe add to cart buttons
        $$('#product-addtocart-button').each(function(elem){
            Event.observe(elem, 'click', function(e){});
        });

        // Set default parent product (init state)
        var originalProductId = null;
        $$("#block-related li.item").each(function(item){
            if($j(item).attr('data-related-default')){
                originalProductId = $j(item).attr('data-related-parent-id');
            }
        });

        // Observer selects (product attributes)
        if($j('.super-attribute-select')){
            var elemLast = $j('.super-attribute-select').last();

            $j('.super-attribute-select').change(function(e){
                e.stopPropagation();
                $('related-products-field').value = ''; // Reset related input when changing parent product
                var selectValue = this.value;

                if(selectValue == "" || selectValue != elemLast.val()){
                    refreshRelatedProduct(originalProductId);
                    return;
                }else{
                    $(this.config.options).each(function(option){
                        if(option.id == selectValue && option.allowedProducts[0]){
                            refreshRelatedProduct(option.allowedProducts[0]);
                            return;

                        }
                    });
                }
            });
        }
    }

        /* Promo Headers */
        (function($j) {
          $j.fn.flowtype = function(options) {
              var settings = $j.extend({
                      maximum: 9999,
                      minimum: 1,
                      maxFont: 9999,
                      minFont: 1,
                      fontRatio: 35
                  }, options),
                  changes = function(el) {
                      var $jel = $j(el),
                          elw = $jel.width(),
                          width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
                          fontBase = width / settings.fontRatio,
                          fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
                      $jel.css('font-size', fontSize + 'px');
                  };
  
              return this.each(function() {
                  var that = this;
                  $j(window).resize(function() {
                      changes(that);
                  });
                  changes(this);
              });
          };
      }(jQuery));
  
          /* Banners Font Size */
          $j('.promo_banner').flowtype({
              minimum: 420,
              maximum: 1600,
              minFont: 14,
              maxFont: 24,
              fontRatio: 40
          });
          $j('.sos_banner').flowtype({
            minimum: 420,
            maximum: 1200,
            minFont: 12,
            maxFont: 16,
            fontRatio: 40
        });
          
      /* End Promo Headers - */
});

function refreshRelatedProduct(childProductId){
    console.log('refresh related product: ' + childProductId);
    $j('.related-checkbox:checked').trigger("click");
    var checkedBoxes = [];

    $$('.related-checkbox').each(function(elem){
        checkedBoxes.push(elem.checked);
    });
    // Display/Don't display li.item elements depending on childProductId selected
    $$("#block-related li.item").each(function(item){
        if(childProductId == $j(item).attr('data-related-parent-id')){
            $j(item).removeClass('no-display');
            // Force show block related
            $j('#block-related').show();

            // Check checked checkboxes
            relatedProductsFieldValue = [];
            $j(item).find('input.related-checkbox').each(function(i, chk){
                if(chk.checked){
                    relatedProductsFieldValue.push(chk.value)
                }
            })
            $('related-products-field').value = relatedProductsFieldValue.join(',');
            $('related-products-qty').value = $j('input#qty').val();
        }else{

            $j(item).addClass('no-display');
        }
    });
}
/* Anniversary Video */
var screenWidth = window.innerWidth;
(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);
window.onload = function() {
  if(!jQuery.browser.mobile || screenWidth >=768) {
    console.log('not-mobile');
    $j("body.cms-home #anniversaryContents")
    .html("<video autoplay loop muted><source src='/skin/frontend/default/swieu/images/video-anniversary.mp4' type='video/mp4' /><source src='/skin/frontend/default/swieu/images/video-anniversary.webm' type='video/webm' /><source src='/skin/frontend/default/swieu/images/video-anniversary.ogv' type='video/ogg' /></video>");                     
  }
  else {
    $j("body.cms-home #anniversaryContents")
    .html("<img src='/skin/frontend/default/swieu/images/logo-anniversary.jpg' />");    
      
  }
}


// Remove Currency Symbol for EUR (need to add GBP, CHF, etc. later)
function removeCurrencySymbol (val) {
  var reg = /€|£|CZK|DKK|PLN|RON|CHF|SEK|AED/g;
  return val.replace(reg, "");
}

/* Misc Global Functions */
function formatPrice (val, lang) {
  console.log('formatPrice', val, lang);
  var price = val;
  if (val) {
    if (lang === 'en') {
      price = price.replace(/\s|,/g, '');
    } else if (lang === 'fr') {
      price = price.replace(/,/g, '.');
      price = price.replace(/\s/g, '');
    } else if (lang === 'de' || lang === 'es') {
      price = price.replace(/\s|\./g, '');
      price = price.replace(/,/g, '.');
    }
    price = removeCurrencySymbol(price);
    console.log('formatPrice Price:', price);
  }

  return price;
}